/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Col } from "reactstrap";
import { useTimer } from "react-timer-hook";
import { padStart } from "lodash";
import { TimerCountDown } from "../../components/timer/timercountdown";
import { useState } from "react";
import { baseUrl, isB2B, isEuro } from "../../libs/env";
import { useCustomOrigin } from "../../components/custom_origin/CustomOriginContext";
import {
  AccountType,
} from "../../components/constants/constants";
export const B2CAssessmentHeader = ({
  assessmentStarted,
  isReview,
  creatQuizDataAndSubmit,
  data,
  isStopTimer,
  setIsStopTimer,
  timer,
  setShowTimeWarning,
  exercise,
}) => {
  let customOrigin = useCustomOrigin();
  let text_color = "text-purple";
  if(isB2B.some(domain => customOrigin.includes(domain))){
    text_color = "text-admin"
  }
  let options = {
    autoStart: false,
  };
  const staticTime = new Date();

  staticTime.setSeconds(staticTime.getSeconds() + parseInt((data.time_allowed_in_minutes) * 60));

  if (staticTime) {
    options = { ...options, expiryTimestamp: staticTime };
  }

  const [saveOnTimeOver, SetSaveOnTimeOver] = useState(false);
    const { seconds, minutes, hours, } = useTimer(options);
    let spent_minutes = padStart([`${minutes}`], [2], ["0"]);
    let spent_seconds = padStart([`${seconds}`], [2], ["0"]);
    let spent_hours = padStart([`${hours}`], [2], ["0"]);
    
  return (
    <div className={`pb-3 row`} xs="1" sm="1" md="4">
      <div className="col-12 px-0 b2c-main">
      {data.user_type === AccountType.STUDENT && !isReview ? null : (
      <div className="row py-3 me-1">
      <div className="col-12">
      <a
        className="btn btn-warning px-4 py-2 rounded-5 d-flex align-items-center justify-content-center"
        href={
          isReview
            ? localStorage.getItem("reportUrl") || `${baseUrl}/user/test-performance/${data?.student_assessment_id}/`
          : "#"
        }
        onClick={(e) => {
          if (data.user_type === AccountType.STAFF && !isReview) {
            e.preventDefault();
            window.close();
          }
        }}
      >
        <div className="d-flex align-items-center">
          <svg
            width="15"
            height="18"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.8332 7.00033H1.1665M1.1665 7.00033L6.99984 12.8337M1.1665 7.00033L6.99984 1.16699"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <b className="ps-2 text-nowrap">
            {data.user_type === AccountType.STAFF
              ? isReview
                ? "Go back to report"
                : "Go back to assignments"
              : "Go back to report"}
          </b>
        </div>
      </a>
      </div>
      </div>
      )}


        <Col className="col-11 d-flex align-items-center ">
          <nav
            className="d-flex"
            Style={`--bs-breadcrumb-divider: url('data:image/svg+xml,<svg width="7" height="11" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="%23A0A0A0" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>');`}
            aria-label="breadcrumb"
          >
            <ol class="breadcrumb mb-0 flex-nowrap">
              <>
                <li class="breadcrumb-item">
                  <a
                    id="breadcrumb_back"
                    href="#"
                    class="text-decoration-none text-nowrap"
                    Style={"color: rgba(71, 84, 103, 1)"}
                  >
                    <strong>{data.label}</strong>
                  </a>
                </li>
                <li class="breadcrumb-item center ps-3 custom_tooltip">
                  <a
                    id="breadcrumb_back"
                    href="#"
                    rel="nofollow"
                    className={`${text_color} bg-white ms-1 px-2 rounded-3 text-decoration-none exercise-text lh-0`}
                  >
                    <strong>{exercise.prompt_content}</strong>
                  </a>
                </li>
              </>
            </ol>
          </nav>
        </Col>
        <Col md className="col-1 center justify-content-end text-nowrap">
          <span>
            <b>
            {window.location.origin.includes(isEuro) && data?.status === "New" && !assessmentStarted ? (
                <div className={`inline`}>
                  <b className="d-flex align-items-center justify-content-center">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 5V11L15 13M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span className="ps-2 fs-8">
                              {spent_hours !== "00" && (
                                <>
                                  <span>{spent_hours}</span>:
                                </>
                              )}
                              <span>{spent_minutes}</span>:<span>{spent_seconds}</span>
                    </span>
                  </b>
                </div>
              ) : !isReview && data && data.status ? (
                <TimerCountDown
                  isStopTimer={isReview ? true : isStopTimer}
                  data={data}
                  localSpentTime={timer}
                  test_time_out={data.allow_late_submissions ? false : true}
                  setShowTimeWarning={setShowTimeWarning}
                  totalTimeInSeconds={data.time_allowed_in_minutes}
                  onStop={(props) => {
                    if (!saveOnTimeOver && !data.allow_late_submissions) {
                      creatQuizDataAndSubmit();
                      alert(
                        "Your test was automatically submitted because you ran out of time."
                      );
                      SetSaveOnTimeOver(true);
                      setIsStopTimer(true);
                    }
                  }}
                />
              ) : null}
            </b>
          </span>
        </Col>
      </div>
      <div className="col-12 px-0 b2c-mobile">
        <Col className="col-12 d-flex align-items-center">
          <div className="col-8 custom_tooltip">
            <span
              href="#"
              class="exercise-text lh-0 text-decoration-none"
              Style={"color: rgba(71, 84, 103, 1)"}
            >
              <strong>{data.label}</strong>
            </span>
          </div>
          <div className="col-4 text-end">
            <b>
              {window.location.origin.includes(isEuro) && data?.status === "New" && !assessmentStarted ? (
                <div className={`inline`}>
                  <b>
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 5V11L15 13M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span className="ps-2 fs-8">
                          {spent_hours !== "00" && (
                            <>
                              <span>{spent_hours}</span>:
                            </>
                          )}
                          <span>{spent_minutes}</span>:<span>{spent_seconds}</span>
                    </span>

                  </b>
                </div>
              ) : !isReview && data && data.status ? (
                <TimerCountDown
                  isStopTimer={isReview ? true : isStopTimer}
                  data={data}
                  localSpentTime={timer}
                  test_time_out={data.allow_late_submissions ? false : true}
                  setShowTimeWarning={setShowTimeWarning}
                  totalTimeInSeconds={data.time_allowed_in_minutes}
                  onStop={(props) => {
                    if (!saveOnTimeOver && !data.allow_late_submissions) {
                      creatQuizDataAndSubmit();
                      alert(
                        "Your test was automatically submitted because you ran out of time."
                      );
                      SetSaveOnTimeOver(true);
                      setIsStopTimer(true);
                    }
                  }}
                />
              ) : null}
            </b>
          </div>
        </Col>
        <Col md className="col-12 center custom_tooltip py-2">
          <span>
            <a
              href="#"
              rel="nofollow"
              className={`${text_color} bg-white ms-1 px-2 rounded-3 text-decoration-none exercise-text lh-0`}
            >
              <strong>{exercise.prompt_content}</strong>
            </a>
          </span>
        </Col>
      </div>
    </div>
  );
};
